import React, { useEffect, useState } from 'react';
import { Table, Button, Space, Typography, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { mappingApi } from '../services/api/mapping';

const { Title } = Typography;

interface DocType {
  id: string;
  name: string;
  parent?: string;
}

const DocTypeList: React.FC = () => {
  const [docTypes, setDocTypes] = useState<DocType[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadDocTypes();
  }, []);

  const loadDocTypes = async () => {
    setLoading(true);
    try {
      const response = await mappingApi.listDocTypes();
      setDocTypes(response.data);
    } catch (error) {
      console.error('Failed to load DocTypes:', error);
      message.error('Failed to load DocTypes');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Parent',
      dataIndex: 'parent',
      key: 'parent',
      render: (parent: string) => parent || '-',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: DocType) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => navigate(`/doctype/${record.id}`)}
          >
            View
          </Button>
          <Button
            type="link"
            onClick={() => navigate(`/doctype/${record.id}/edit`)}
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Title level={2}>Document Types</Title>
        <Table
          columns={columns}
          dataSource={docTypes}
          rowKey="id"
          loading={loading}
          pagination={false}
        />
      </Space>
    </div>
  );
};

export default DocTypeList;